import { NotificationItem } from '@nxsys/store/slices/notification/types';

type GetNotificationRouteOptions = {
  isEmployee?: boolean;
  isAgency?: boolean;
  isIreland?: boolean;
};

export const getNotificationRoute = (
  notification: NotificationItem,
  options?: GetNotificationRouteOptions,
): string | null => {
  const { notificationType, fromId, subType } = notification;
  const isEmployee = options?.isEmployee ?? false;
  const isAgency = options?.isAgency ?? false;
  const isIreland = options?.isIreland ?? false;

  switch (notificationType) {
    case 'TIMESHEET_ACCEPTED':
    case 'APPROVAL_TIMESHEET':
    case 'SUBMITED_TIMESHEET':
      if (isEmployee) {
        return fromId
          ? `/timesheets-employee/${fromId}`
          : '/timesheets-employee';
      }
      if (isAgency) {
        return fromId ? `/timesheets-agency/${fromId}` : '/timesheets-agency';
      }
      return fromId ? `/timesheets/${fromId}` : '/timesheets';

    // NX-5237: a tax-period change on an approved timesheet sends it back for
    // re-approval. Land each side where it can act: the approver on the Pending
    // Agency Approval screen (the detail screen has no approve action), the
    // agency on the timesheet itself so the Reason is right there.
    case 'TAX_PERIOD_UPDATED_AFTER_APPROVAL':
      if (isEmployee) return null;
      if (isAgency) {
        return fromId ? `/timesheets-agency/${fromId}` : '/timesheets-agency';
      }
      return '/timesheets/pending';

    case 'RASIED_INVOICE':
    case 'RECEIVED_INVOICE':
      if (isEmployee) return null;
      return fromId ? `/invoices/invoice/${fromId}` : '/invoices';

    case 'RASIED_CREDIT':
    case 'RECEIVED_CREDIT':
      if (isEmployee) return null;
      return fromId
        ? `/invoices/credit-note/${fromId}`
        : '/invoices/credit-notes';

    case 'APPROVAL_DRAFT_PAYROLL':
    case 'REJECT_DRAFT_PAYROLL':
    case 'REQUEST_APPROVAL_DRAFT_PAYROLL':
      if (isEmployee || isAgency) return null;
      return '/payroll';

    case 'DOCUMENT_SUBMITED':
      if (isEmployee) return '/employee-documents';
      if (isAgency) return '/agency-documents';
      return '/documents';

    case 'UPDATE_BANK':
      if (isEmployee) return '/general?tab=BANK_INFORMATION';
      if (isAgency) return null;
      if (subType === 'agency') {
        return fromId ? `/agency/${fromId}?tab=PAYROLL_AND_FINANCE` : '/agency';
      }
      return fromId
        ? `/employees-subcontractors/${fromId}?tab=BANK_INFORMATION`
        : '/employees-subcontractors';

    case 'INFO_UPDATED':
    case 'ADDRESS_UPDATED':
    case 'PUT_ON_HOLD':
      if (isEmployee) return '/general?tab=GENERAL_INFORMATION';
      if (isAgency) return null;
      return fromId
        ? `/employees-subcontractors/${fromId}?tab=GENERAL_INFORMATION`
        : '/employees-subcontractors';

    case 'VAT_NUMBER_UPDATED':
      if (isEmployee) return '/general?tab=SETTINGS_GENERAL';
      return fromId
        ? `/employees-subcontractors/${fromId}?tab=SETTINGS_GENERAL`
        : '/employees-subcontractors';

    case 'CONFIRM_PAYMENT':
      if (isEmployee || isAgency) return null;
      // NX-5774: the CIS Payment Summary is UK-only and not routed for Ireland.
      return isIreland
        ? '/reports/payroll/payment-summary'
        : '/reports/payroll/cis-payment-summary';

    default:
      return null;
  }
};
